"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconDownAndUpArrows = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconDownAndUpArrows = function SvgIconDownAndUpArrows(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#si_downuparrows__clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.989 12a.747.747 0 01-.542-.222L.22 9.538a.757.757 0 01.243-1.23.747.747 0 01.817.163l.97.975V2.25a.75.75 0 011.5 0v7.196l.97-.975a.747.747 0 011.06 0 .758.758 0 010 1.067l-2.227 2.24a.745.745 0 01-.564.222zM9.01 0a.746.746 0 01.542.221l2.227 2.241a.758.758 0 010 1.067.747.747 0 01-1.06 0l-.97-.975V9a.75.75 0 11-1.5 0V2.554l-.97.975a.746.746 0 01-1.06 0 .758.758 0 010-1.067L8.447.221A.746.746 0 019.011 0z",
    fill: "currentColor"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "si_downuparrows__clip0"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  }))));
};

exports.SvgIconDownAndUpArrows = SvgIconDownAndUpArrows;